import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { SetStateAction, useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Panel } from "primereact/panel";
import React from "react";
import { Messages } from "primereact/messages";
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from "primereact/tree";
import getPermissao from "../../service/getPermissao";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";

export default function OpcaoConsultaLoteCadastrar({opcaoConsulaLote, onClose, onSave}:{opcaoConsulaLote:any, onClose: () => void, onSave: (opcaoConsulaLote:any) => void}) {
  const { t } = useTranslation();
  const [showExportacao, setShowExportacao] = useState<boolean>(false);
  const [exportacoes, setExportacoes] = useState<any[]>(opcaoConsulaLote?.exportacoes);
  const [nome, setNome] = useState<string>();
  const [localizacao, setLocalizacao] = useState<string>();
  const [ordem, setOrdem] = useState<number|null>();
  const [exportacaoEdit, setExportacaoEdit] = useState<any>();
  const msgs = useRef<Messages>(null);
  const [nodes, setNodes] = useState<any[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>(null); 
  const [selectedTipoConsulta, setselectedTipoConsulta] = useState<number|undefined>(opcaoConsulaLote.tipoOpcaoConsulta ? (opcaoConsulaLote.tipoOpcaoConsulta === 'PF' ? 0 : 1) : undefined);
  const [idsPermissoes, setIdsPermissoes] = useState<any[]>([]);
  const defaultValues = {
    nome: ''
  };
  defaultValues.nome = opcaoConsulaLote.nome ? opcaoConsulaLote.nome.toString() : ''
 
  const tiposConsulta = [
    { name: 'Selecione', code: null },
    { name: 'Consulta Pessoa Física', code: 0 },
    { name: 'Consulta Pessoa Jurídica', code: 1 }
  ];

  const createPermissoes = () => {
    if(selectedTipoConsulta == 0 || selectedTipoConsulta == 1){
      getPermissao().then(data => {
        const optionsPF = data.filter((f: {
          agrupadorConsulta: boolean; tipoConsulta: string; 
  }) => f.agrupadorConsulta == false && (f.tipoConsulta === (selectedTipoConsulta == 0 ? 'PF' : 'PJ') || f.tipoConsulta === 'PFPJ'))
  optionsPF.sort((s1:{ label: string}, s2:{label: string}) => {
    const nameA = s1.label.toUpperCase(); // ignore upper and lowercase
    const nameB = s2.label.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
  
    // names must be equal
    return 0;
  })      
  optionsPF.forEach((element: {
          children: any; label: string; value: string; permissoes:any[] 
  }) => {
          
          verifyChecked(element);
          if(element.children){
            element.children.forEach((child:any) => {verifyChecked(child)})
          }
          option.push({label:element.label, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(element.permissoes.filter((f: {
            agrupadorConsulta: boolean; tipoConsulta: string; 
  }) => f.agrupadorConsulta == false && (f.tipoConsulta === (selectedTipoConsulta == 0 ? 'PF' : 'PJ') || f.tipoConsulta === 'PFPJ'))) : element.children });
        });
      })
    }
    
    const option : any[] = [];
    
    
   
    return option;
  }
  const createPermissoesFilhos = (permissoes:any[]) => {
    const option : any[] = [];
    if(permissoes){
      permissoes.sort((s1:{ label: string}, s2:{label: string}) => {
        const nameA = s1.label.toUpperCase(); // ignore upper and lowercase
        const nameB = s2.label.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      
        // names must be equal
        return 0;
      })
      permissoes.forEach((element: {
        children: any; label: string; value: string; permissoes:any[]  
  }) => {
        
  
        verifyChecked(element);
        if(element.children){
          element.children.forEach((child:any) => {verifyChecked(child)})
        }
  
        option.push({label:element.label, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(element.permissoes.filter((f: {
          agrupadorConsulta: boolean; tipoConsulta: string; 
  }) => f.agrupadorConsulta == false && (f.tipoConsulta === (selectedTipoConsulta == 0 ? 'PF' : 'PJ') || f.tipoConsulta === 'PFPJ'))) : element.children});
      });
    }
    return option;
  }

  const verifyChecked = (element:any) => {
  
    if(opcaoConsulaLote && opcaoConsulaLote.opcaoConsulta){
      
      const checked = opcaoConsulaLote.opcaoConsulta.find((k:string) => k == element.value);
  
      if(checked){
        idsPermissoes.push(element.value)
        const selectedKeysChecked: SetStateAction<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null> = {
      
        }
  
        idsPermissoes.forEach(id => {
          selectedKeysChecked[id] = {
            partialChecked: false,
            checked: true
          }
        });
        
       setSelectedKeys(selectedKeysChecked);
      }
    }
  }
  
  const {
      control,
      formState: { errors},
      handleSubmit
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.nome  && save(data);
  };

  const salvarExportacao = () => {
    if(nome && localizacao){
      const lista = []
      exportacoes?.forEach((p) => lista.push(p))
      const results = exportacoes?.filter((p) => p.nome === nome)
      if(results && results.length !== 0 && (!exportacaoEdit || exportacaoEdit.nome !== nome)){
        msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Exportação já existe', closable: false }
           
        ]);
        window.scrollTo(0, 0);
      }
      else{
        if(!exportacaoEdit){
          lista.push({nome:nome, localizacao:localizacao, ordem:ordem})
        }
        else{
          exportacaoEdit.nome = nome;
          exportacaoEdit.localizacao = localizacao;
          exportacaoEdit.ordem = ordem;
        }
        setExportacoes(lista)
        setNome('')
        setLocalizacao('')
        setOrdem(null);
        setShowExportacao(false)
      }
    }
    else{
      msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Nome e Localização obrigatórios', closable: false }
           
        ]);
        window.scrollTo(0, 0);
    }
  }
 
  const save = (data:any) => {
    const opcoes: string[] = [];
    if(selectedKeys){
      Object.getOwnPropertyNames(selectedKeys).map((item) => opcoes.push(item));
    }
    const opcao = {
      id: opcaoConsulaLote.id? opcaoConsulaLote.id : undefined,
      nome:data.nome,
      opcaoConsulta: opcoes,
      exportacoes:exportacoes,
      tipoOpcaoConsulta: selectedTipoConsulta == 0 ? 'PF' : 'PJ'
    }
    window.scrollTo(0, 0);
    onSave(opcao);
  }
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const editItemBodyTemplate = (item:any) => {
    return <>
      <Button icon="pi pi-pencil" type="button" onClick={(e) => {setLocalizacao(item.localizacao); setNome(item.nome); setOrdem(item.ordem); setExportacaoEdit(exportacoes.filter((s) => s.nome === item.nome)[0]);  setShowExportacao(true);}} style={{background:'transparent', color:'gray', border: 'none'}} />
      <Button icon="pi pi-trash" type="button" onClick={() => {setExportacoes(exportacoes?.filter((s) => s.nome !== item.nome))}} style={{background:'transparent', color:'gray', border: 'none'}} />
    </>
  };

  useEffect(() => {
    setNodes(createPermissoes());
    
  },[selectedTipoConsulta])

  const paginatorRight = (
    <React.Fragment>
        {!showExportacao && (
          <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Adicionar Exportação" onClick={()=>setShowExportacao(true)} />
          </div>
          )
        }
          {showExportacao && (
            <Panel>
               
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="servico" className="font-bold block mb-2 required">{t('nome')} </label>
                    <InputText value={nome} onChange={(e) => setNome(e.target.value)} />
                  </div>
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="ordem" className="font-bold block mb-2">{t('ordem')} </label>
                    <InputNumber value={ordem} onChange={(e) => setOrdem(e.value)} />
                  </div>
                </div>
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="localizacao" className="font-bold block mb-2 required">{t('localizacao')} </label>
                    <InputText value={localizacao} onChange={(e) => setLocalizacao(e.target.value)} />
                  </div>
                </div>
                <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
                  <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar Exportação" onClick={()=>salvarExportacao()} />
                  <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => setShowExportacao(false)} className="p-button-text" />
                </div>
             
            
            </Panel>
          )}
          
    </React.Fragment>
    );


  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="nome"
                      control={control}
                      rules={{ required: 'Nome é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.nome })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="descricao" className="font-bold block mb-2 required">{t('nome')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
              <div className="col">
                                  <label htmlFor="permissaoPai" className="font-bold block mb-2 required">{t('tipoConsulta')} </label>
                                  <Dropdown disabled={opcaoConsulaLote.id} value={selectedTipoConsulta}  onChange={(e) => setselectedTipoConsulta(e.value)} options={tiposConsulta} optionLabel="name" 
                                    placeholder="Selecione o tipo Consulta" optionValue='code' style={{width:'100%'}} className="w-full md:w-14rem" />
                                </div>
          </div>
          <Tree expandIcon={undefined} collapseIcon={undefined} value={nodes} selectionMode="checkbox" selectionKeys={selectedKeys} onSelectionChange={(e) => setSelectedKeys(e.value)} />
          <br></br>
          <DataTable size="small" paginatorRight={paginatorRight} footer={paginatorRight} value={exportacoes} tableStyle={{ minWidth: '50rem' }}>
            <Column field="nome" header={t('nome')}></Column>
            <Column field="localizacao" header={t('localizacao')}></Column>
            <Column body={editItemBodyTemplate} />
          </DataTable>
       
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}

